export default function Footer() {
  return (
    <footer className="bg-dark text-light border-top border-secondary py-3 mt-auto">
      <div className="container text-center">
        <small className="text-secondary">
          © 2026 MyTodoList — All rights reserved
        </small>
      </div>
    </footer>
  );
}
